import { useDashData } from "../hooks/useDashData";
import PageHeader from "../components/layout/PageHeader";
import ServiceRanking from "../components/dashboard/ServiceRanking";
import ServiceMatrix from "../components/dashboard/ServiceMatrix";

export default function Services() {
  const { data: matrix } = useDashData("/analytics/service-matrix");

  return (
    <div className="space-y-6 animate-fade-up">
      <PageHeader title="Service Deep-Dive"
        subtitle="Where spend goes, what converts cheapest, and which lines drive the most return" />
      <ServiceRanking matrix={matrix} />
      <ServiceMatrix matrix={matrix} />
    </div>
  );
}
